import React from 'react'
import { notification, Icon } from 'antd'
import { t } from 'ab18n'

import history from 'shared/history'

const setNotification = (message, duration, onClose) => (
  notification.error({
    message,
    duration,
    onClose: () => {
      if (onClose) {
        history.push(onClose)
      }
    }
  })
)

const setForbiddenNotification = () => {
  const btn = (
    <Icon
      onClick={() => {
        notification.close('forbidden')
        history.push('/store/kits')
      }
      }
      type="close"
    />
  )

  notification.error({
    key: 'forbidden',
    message: t('general.notification.forbidden'),
    duration: null,
    className: 'forbidden-notification',
    icon: <Icon type="warning" />,
    btn,
  })
}

// achata os erros (podem vir aninhados por kit/produto) e mostra cada produto uma vez só,
// mantendo a última mensagem dele
export const uniqueErrorMessages = (errors) => {
  const flatten = value => (
    Array.isArray(value) || (value && typeof value === 'object')
      ? Object.values(value).reduce((acc, item) => acc.concat(flatten(item)), [])
      : [value]
  )
  const byProduct = new Map()
  flatten(errors)
    .filter(message => typeof message === 'string' && message.trim() !== '')
    .forEach((message) => {
      const productName = (message.match(/"([^"]+)"/) || [])[1]
      byProduct.set(productName || message, message)
    })
  return [...byProduct.values()]
}

export default function errorsFormat(
  error,
  message,
  duration = null,
  onClose = null,
) {
  if (error.response && error.response.status !== 401) {
    if (error.response.status >= 500) {
      setNotification(message, duration, onClose)
    } else if (error.response.status === 404) {
      setNotification(t('general.notification.error'), duration, onClose)
    } else if (error.response.status === 403) {
      setForbiddenNotification()
    } else {
      const { response: { data: { errors } } } = error
      const customErrors = errors !== undefined ? uniqueErrorMessages(errors) : []

      setNotification(
        customErrors.length > 0
          ? customErrors.map(item => (
            <div className="custom-error" key={item}>{ item }</div>
          ))
          : message,
        duration,
        onClose,
      )
    }
  }
}
